(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1614],{

/***/ 65868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"lineCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineNodeInput"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"edges"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LineEdgeInput"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLineWithTopology"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"nodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nodes"}}},{"kind":"Argument","name":{"kind":"Name","value":"edges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"edges"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Node"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NodeSensor"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":568}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/line/node-with-sensor.gql\'\\n\\nmutation lineCreate(\\n  $groupId: ID!\\n  $name: String!\\n  $description: String\\n  $nodes: [LineNodeInput!]!\\n  $edges: [LineEdgeInput!]! # $bottleneckId: ID! # $sensorConfig: SensorConfigInput!\\n) {\\n  createLineWithTopology(groupId: $groupId, name: $name, description: $description, nodes: $nodes, edges: $edges) {\\n    id\\n    name\\n    description\\n    nodes {\\n      ...Node\\n      sensor {\\n        ...NodeSensor\\n      }\\n    }\\n    edges {\\n      from\\n      to\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(49478).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.lineCreate = oneQuery(doc, "lineCreate");
        


/***/ }),

/***/ 18828:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sensorGroups"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":336}}');
    doc.loc.source = JSON.parse('{"body":"query sensorGroups {\\n  company {\\n    id\\n    groups {\\n      id\\n      name\\n      sensors {\\n        _id\\n        name\\n        description\\n        peripheralId\\n        peripheralType\\n        config {\\n          type\\n        }\\n        peripheralInformation {\\n          node {\\n            peripheralId\\n          }\\n        }\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.sensorGroups = oneQuery(doc, "sensorGroups");
        


/***/ }),

/***/ 19536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ overview_top_bar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(96741);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(35422);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(15015);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+base@5.0.0-alpha.125_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(51285);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(73469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(96620);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+system@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react@17.0.2/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(39481);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-select@3.2.0_react-dom@17.0.2_react@17.0.2/node_modules/react-select/creatable/dist/react-select.browser.esm.js + 18 modules
var react_select_browser_esm = __webpack_require__(63554);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./components/bars/search-bar.tsx


























var styles = function(theme) {
    return {
        root: {
            flex: 1
        },
        input: {
            display: "flex",
            padding: 0,
            height: theme.spacing(5)
        },
        valueContainer: {
            display: "flex",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
            overflow: "hidden"
        },
        chip: {
            margin: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(0.25))
        },
        chipFocused: {
            backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
        },
        noOptionsMessage: {
            padding: "".concat(theme.spacing(), "px ").concat(theme.spacing(2))
        },
        singleValue: {
            fontSize: 16
        },
        placeholder: {
            position: "absolute",
            left: 2,
            fontSize: 16
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(),
            left: 0,
            right: 0
        },
        divider: {
            height: theme.spacing(2)
        }
    };
};
function NoOptionsMessage(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.noOptionsMessage
    }, props.innerProps), {
        children: props.children
    }));
}
function inputComponent(_param) {
    var inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputRef"
    ]);
    // NOTE: Order is important, InputBase sets ref to null, thus we ensure it's
    // value by setting ref after the spread.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: inputRef
    }));
}
function Control(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        variant: "filled",
        fullWidth: true,
        InputProps: {
            inputComponent: inputComponent,
            inputProps: (0,_object_spread/* default */.Z)({
                className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.input,
                inputRef: props.innerRef,
                children: props.children
            }, props.innerProps)
        }
    }, props.selectProps.textFieldProps));
}
function Option(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            minWidth: 0,
            padding: "5px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: props.innerRef,
            selected: props.isFocused,
            component: "div",
            style: {
                fontWeight: props.isSelected ? 500 : 400,
                width: "100%"
            }
        }, props.innerProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: [
                    " ",
                    props.children,
                    " "
                ]
            })
        }))
    });
}
function Placeholder(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.placeholder
    }, props.innerProps), {
        children: props.children
    }));
}
function SingleValue(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.singleValue
    }, props.innerProps), {
        children: props.children
    }));
}
function ValueContainer(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.valueContainer,
        children: props.children
    });
}
function MultiValue(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        tabIndex: -1,
        label: props.children,
        className: (0,clsx_m["default"])((ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.chip, (0,_define_property/* default */.Z)({}, (ref1 = props.selectProps.classes) === null || ref1 === void 0 ? void 0 : ref1.chipFocused, props.isFocused)),
        onDelete: props.removeProps.onClick,
        deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, (0,_object_spread/* default */.Z)({}, props.removeProps))
    });
}
function Menu(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        square: true,
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.paper
    }, props.innerProps), {
        children: props.children
    }));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
};
var createOption = function(label) {
    return {
        label: label,
        value: {
            type: "string",
            value: label
        }
    };
};
var SearchBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SearchBar, _Component);
    var _super = (0,_create_super/* default */.Z)(SearchBar);
    function SearchBar() {
        (0,_class_call_check/* default */.Z)(this, SearchBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputValue: ""
        };
        _this.formatLabel = function(val) {
            return "".concat(_this.props.t([
                "shared:searchFor"
            ], {
                defaultValue: "Search for"
            }), ' "').concat(val, '"');
        };
        _this.createOption = function(inputValue) {
            return _this.props.handleChange((0,_to_consumable_array/* default */.Z)(_this.props.value).concat([
                createOption(inputValue)
            ]));
        };
        _this.handleChange = function(val) {
            _this.props.handleChange(Array.isArray(val) ? val : val ? [
                val
            ] : []);
        };
        return _this;
    }
    var _proto = SearchBar.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, value = _props.value, theme = _props.theme, suggestions = _props.suggestions, t = _props.t;
        var selectStyles = {
            input: function(base) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                    color: theme.palette.text.primary,
                    "& input": {
                        font: "inherit"
                    }
                });
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                style: {
                                    marginRight: theme.spacing(),
                                    backgroundColor: "#269AE0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            style: {
                                flexGrow: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                                classes: classes,
                                styles: selectStyles,
                                textFieldProps: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                createOptionPosition: "first",
                                formatCreateLabel: this.formatLabel,
                                options: suggestions,
                                components: components,
                                value: value,
                                onCreateOption: this.createOption,
                                onChange: this.handleChange,
                                placeholder: "".concat(t([
                                    "shared:typeToSearch"
                                ], {
                                    defaultValue: "Type to search"
                                }), "..."),
                                isMulti: true,
                                isClearable: true
                            })
                        })
                    ]
                })
            })
        });
    };
    return SearchBar;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var search_bar = (enhance(SearchBar));

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
;// CONCATENATED MODULE: ./components/bars/overview-top-bar.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            overflow: "visible",
            marginBottom: theme.spacing(),
            "@media print": {
                display: "none"
            }
        },
        content: {
            paddingBottom: theme.spacing(2)
        },
        divContainer: {
            display: "flex",
            width: "100%",
            flexWrap: "nowrap"
        },
        hideOnSMDown: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        hideOnMDup: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.up("md"), {
            display: "none"
        })
    };
});
var OverviewTopBar = function(param) {
    var suggestions = param.suggestions, search = param.search, children = param.children, totalCount = param.totalCount, page = param.page, pageSize = param.pageSize, handleSearchChange = param.handleSearchChange, handlePageChange = param.handlePageChange;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        elevation: 1,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: classes.content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.divContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar, {
                            suggestions: suggestions,
                            value: search,
                            handleChange: handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.hideOnSMDown,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                }),
                                children
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.hideOnMDup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        justifyContent: "space-between",
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var overview_top_bar = (OverviewTopBar);


/***/ }),

/***/ 4228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53236);
/* harmony import */ var _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65680);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);






var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        stickyBottom: {
            // Escape the grouped stacking context to avoid filter/opacity bleeding effects.
            zIndex: 1,
            bottom: theme.spacing(4),
            height: 68,
            marginBottom: theme.spacing(3),
            position: "sticky",
            width: 1,
            left: "100%",
            "@media print": {
                display: "none"
            }
        },
        bottomRight: {
            position: "absolute",
            bottom: 0,
            right: theme.spacing(3)
        }
    };
});
var StickyFab = function(param) {
    var children = param.children, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _title = param.title, title = _title === void 0 ? "" : _title, onClick = param.onClick, _Icon = param.Icon, Icon = _Icon === void 0 ? _mui_icons_material_Add__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _Icon;
    var classes = useStyles().classes;
    var child = children && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
        className: classes.bottomRight
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        color: "primary",
        disabled: disabled,
        className: classes.bottomRight,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {})
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.stickyBottom,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            title: title,
            placement: "top-start",
            children: button
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyFab);


/***/ }),

/***/ 60840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28066);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14724);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61978);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99109);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 35606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81666);
/* harmony import */ var _mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54936);
/* harmony import */ var _mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56646);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14724);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5887);


















var styles = function(theme) {
    var _obj;
    return {
        pagination: {
            alignItems: "center",
            marginLeft: "1em",
            display: "flex"
        },
        buttons: {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center"
        },
        rowsLabel: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            whiteSpace: "nowrap"
        }, theme.typography.caption), (_obj = {
            paddingRight: theme.spacing(5)
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
            paddingRight: "0"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "lineHeight", theme.spacing(5)), _obj)),
        button: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            color: "inherit",
            minWidth: theme.spacing(2),
            height: theme.spacing(5)
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        activeButton: {
            fontWeight: "bold",
            cursor: "default"
        },
        arrowButton: {
            transform: theme.direction === "rtl" ? "rotate(180deg)" : undefined
        }
    };
};
var PageButton = function(args) {
    var text = args.text, isActive = args.isActive, isDisabled = args.isDisabled, classes = args.classes, onClick = args.onClick;
    var _obj;
    var buttonClasses = (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.button, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.activeButton, isActive), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: buttonClasses,
        disabled: isDisabled,
        onClick: onClick,
        disableRipple: isActive,
        children: text
    });
};
var ellipsisSymbol = "…";
var Paginator = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Paginator, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Paginator);
    function Paginator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, Paginator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setPage = function(desiredPage) {
            return function() {
                return _this.props.onCurrentPageChange(desiredPage);
            };
        };
        _this.renderPageButtons = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, classes = _props.classes;
            var pageButtons = [];
            var maxButtonCount = 3;
            var startPage = 1;
            var endPage = totalPages || 1;
            if (maxButtonCount < totalPages) {
                startPage = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .calculateStartPage */ .kw6)(currentPage + 1, maxButtonCount, totalPages);
                endPage = startPage + maxButtonCount - 1;
            }
            if (startPage > 1) {
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(1),
                    classes: classes,
                    onClick: _this.setPage(0)
                }, 1));
                if (startPage > 2) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisStart"));
                }
            }
            for(var page = startPage; page <= endPage; page += 1){
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(page),
                    isActive: page === currentPage + 1,
                    classes: classes,
                    onClick: _this.setPage(page - 1),
                    isDisabled: startPage === endPage
                }, page));
            }
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisEnd"));
                }
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(totalPages),
                    classes: classes,
                    onClick: _this.setPage(totalPages - 1)
                }, totalPages));
            }
            return pageButtons;
        };
        _this.previousPage = function() {
            var _props = _this.props, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage > 0 && onCurrentPageChange(currentPage - 1);
        };
        _this.nextPage = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage < totalPages - 1 && onCurrentPageChange(currentPage + 1);
        };
        return _this;
    }
    var _proto = Paginator.prototype;
    _proto.render = function render() {
        var _props = this.props, totalPages = _props.totalPages, totalCount = _props.totalCount, pageSize = _props.pageSize, currentPage = _props.currentPage, classes = _props.classes, t = _props.t;
        var from = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .firstRowOnPage */ .dF$)(currentPage, pageSize, totalCount);
        var to = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .lastRowOnPage */ .ZN$)(currentPage, pageSize, totalCount);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.pagination,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.rowsLabel,
                    children: "".concat(from).concat(from < to ? "-".concat(to) : "", " ").concat(t([
                        "shared:pageOf"
                    ], {
                        defaultValue: "of"
                    }), " ").concat(totalCount)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === 0,
                            onClick: this.previousPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                        }),
                        this.renderPageButtons(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === totalPages - 1 || totalCount === 0,
                            onClick: this.nextPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            ]
        });
    };
    return Paginator;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles, {
    name: "Paginator"
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Paginator));


/***/ }),

/***/ 23415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isSearchValueType; }
/* harmony export */ });
var isSearchValueType = function(searchValue) {
    return searchValue.label !== undefined;
};


/***/ }),

/***/ 40510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ getDayEnumFromDay; },
/* harmony export */   "Dd": function() { return /* binding */ getShiftFromShifts; },
/* harmony export */   "VL": function() { return /* binding */ convertGenericShiftTimeToDatePair; },
/* harmony export */   "XS": function() { return /* binding */ getDaySortNumber; },
/* harmony export */   "bb": function() { return /* binding */ unrollSchedule; },
/* harmony export */   "dl": function() { return /* binding */ getYearWeek; },
/* harmony export */   "g_": function() { return /* binding */ getDayStringOfEnum; },
/* harmony export */   "ku": function() { return /* binding */ getDayNumberOfEnum; },
/* harmony export */   "yV": function() { return /* binding */ mkAppointmentsFromShifts; }
/* harmony export */ });
/* unused harmony exports extractCurrentSchedule, shiftDuration */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48417);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19852);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25955);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52108);





// CC-BY-CA: https://stackoverflow.com/a/6117889
var getYearWeek = function(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    // Return array of year and week number
    return {
        year: d.getUTCFullYear(),
        week: weekNo
    };
};
/**
 * Extract the schedule that is valid in the date you request. If not supplied
 * an array of schedules, it will return the schedule immediately.
 */ var extractCurrentSchedule = function(schedules, date) {
    var target = getYearWeek(date);
    if (!Array.isArray(schedules)) {
        return schedules;
    }
    // If we only have one schedule (usually the case from our request), we take it directly.
    if (schedules.length === 1) {
        return schedules[0];
    } else if (schedules.length > 1) {
        // If we are given more schedules, find the one that is the currently active one, based on the `validFrom` periods.
        var activeSchedule;
        schedules.map(function(schedule) {
            if (schedule.validFrom.year <= target.year && schedule.validFrom.week <= target.week) {
                // If no schedule has been set, just set the initial one.
                if (!activeSchedule) {
                    activeSchedule = schedule;
                    return;
                }
                // Check if the schedule's validFrom period is closer to our target, than the current `activeSchedule`.
                var scheduleYearDiff = target.year - schedule.validFrom.year;
                var activeScheduleYearDiff = target.year - activeSchedule.validFrom.year;
                var scheduleWeekDiff = target.week - schedule.validFrom.week;
                var activeScheduleWeekDiff = target.week - activeSchedule.validFrom.week;
                if (scheduleYearDiff <= activeScheduleYearDiff && scheduleWeekDiff < activeScheduleWeekDiff) {
                    activeSchedule = schedule;
                    return;
                }
            }
        });
        return activeSchedule;
    }
    return undefined;
};
/**
 * Convert a `DayOfWeek` enum to a string.
 */ var getDayStringOfEnum = function(t, dayOfWeek) {
    switch(dayOfWeek){
        case 0:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return t([
                "shared:sunday"
            ], {
                defaultValue: "Sunday"
            });
        case 1:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
        case 2:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return t([
                "shared:tuesday"
            ], {
                defaultValue: "Tuesday"
            });
        case 3:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return t([
                "shared:wednesday"
            ], {
                defaultValue: "Wednesday"
            });
        case 4:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return t([
                "shared:thursday"
            ], {
                defaultValue: "Thursday"
            });
        case 5:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return t([
                "shared:friday"
            ], {
                defaultValue: "Friday"
            });
        case 6:
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return t([
                "shared:saturday"
            ], {
                defaultValue: "Saturday"
            });
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return t([
                "shared:monday"
            ], {
                defaultValue: "Monday"
            });
    }
};
/**
 * Convert a day 'number' into a `DayOfWeek` enum.
 */ var getDayEnumFromDay = function(dayOfWeek) {
    switch(dayOfWeek){
        case 0:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
        case 1:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
        case 2:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY;
        case 3:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY;
        case 4:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY;
        case 5:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY;
        case 6:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY;
        default:
            return generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY;
    }
};
/**
 * Convert a `DayOfWeek` enum to a sortable number, rotating it based on `startDayOfWeek`.
 */ var getDaySortNumber = function(dayOfWeek) {
    var startDayOfWeek = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY;
    // Figure out what the start day is so we can rotate by this number.
    var foundStartDay = getDayNumberOfEnum(startDayOfWeek);
    var sortNumber = 0;
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            sortNumber = 0 < foundStartDay ? 0 + 7 : 0;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            sortNumber = 1 < foundStartDay ? 1 + 7 : 1;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            sortNumber = 2 < foundStartDay ? 2 + 7 : 2;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            sortNumber = 3 < foundStartDay ? 3 + 7 : 3;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            sortNumber = 4 < foundStartDay ? 4 + 7 : 4;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            sortNumber = 5 < foundStartDay ? 5 + 7 : 5;
            break;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            sortNumber = 6 < foundStartDay ? 6 + 7 : 6;
            break;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            sortNumber = 1;
            break;
    }
    return sortNumber;
};
/**
 * Convert a `DayOfWeek` enum to a number. We default to Monday (i.e. 1).
 */ var getDayNumberOfEnum = function(dayOfWeek) {
    switch(dayOfWeek){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY:
            return 0;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.MONDAY */ .eO.MONDAY:
            return 1;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.TUESDAY */ .eO.TUESDAY:
            return 2;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.WEDNESDAY */ .eO.WEDNESDAY:
            return 3;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.THURSDAY */ .eO.THURSDAY:
            return 4;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.FRIDAY */ .eO.FRIDAY:
            return 5;
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY:
            return 6;
        default:
            _types__WEBPACK_IMPORTED_MODULE_1__/* .assertUnreachable */ .U(dayOfWeek);
            return 1;
    }
};
/**
 * Convert a schedule shift element into a appointment element needed for the calendar widget.
 *
 * This part gets a little hairy. We need to convert the generic "Monday 8 - 16" into a specific
 * date on the calendar, based on the dates we are shown. Furthermore, these dates can change, depending
 * on the start day of the week that the user has configured.
 *
 * We first figure out if the calendar if the start day of the calendar is after our current date, which
 * will mean that the week view is shifted one week back.
 *
 * Then we take the day of the shift event, e.g. Monday, and subtract the start day, e.g. Tuesday. If
 * this day is lower than 0, we know that we are on a date before the start date, and we need to add 7
 * days to the result of this, because we previously accounted for the shift in the week view.
 *
 * Finally, we can get the dates from the current date + the shift in week view + the shift from start
 * date.
 */ var convertGenericShiftTimeToDatePair = function(timeRange, date, startDay) {
    var from = timeRange.from, to = timeRange.to;
    var dayOfStartDay = getDayNumberOfEnum(startDay);
    var dayOfShiftStart = getDayNumberOfEnum(from.day);
    var dayOfShiftEnd = getDayNumberOfEnum(to.day);
    var currentDayInWeek = date.getDay();
    if (dayOfShiftEnd < dayOfShiftStart) {
        dayOfShiftEnd += 7;
    }
    // If the start day is before the current day of the week, we must shift our days back.
    var shiftToLastWeek = 0;
    if (currentDayInWeek < dayOfStartDay) {
        // We shift it back a week, and then add the days in that week that has already passed.
        shiftToLastWeek = -7 + (dayOfStartDay - currentDayInWeek);
    } else {
        shiftToLastWeek = dayOfStartDay - currentDayInWeek;
    }
    // Shift the day of the shift based on the start day of the schedule.
    var shiftForStartDate = dayOfShiftStart - dayOfStartDay;
    if (shiftForStartDate < 0) {
        // If it's below 0, that's because it wrapped around, so we subtract the shift from 7.
        shiftForStartDate = 7 + shiftForStartDate;
    }
    // Finally, we create a new date from this shift in days.
    var shiftedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    shiftedDate.setDate(shiftedDate.getDate() + shiftToLastWeek + shiftForStartDate);
    var wrapShift = dayOfShiftEnd < dayOfShiftStart;
    var shiftShift = wrapShift ? dayOfShiftStart - 1 : dayOfShiftEnd - dayOfShiftStart;
    return {
        from: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate(), from.hour, from.minute),
        to: new Date(shiftedDate.getFullYear(), shiftedDate.getMonth(), shiftedDate.getDate() + shiftShift, to.hour, to.minute)
    };
};
/**
 * Convert a shift into an appointment, for use with our DX Scheduler component. An
 * appointment looks something like (as a minimum):
 * ```
{
  title: 'Website Re-Design Plan',
  startDate: new Date(2019, 4, 15, 9, 30),
  endDate: new Date(2019, 4, 15, 11, 30),
  id: 0,
  location: 'Room 1',
}
```
 */ var mkAppointmentsFromShifts = function(shifts, date, startDay) {
    var ref = convertGenericShiftTimeToDatePair({
        from: {
            day: startDay,
            hour: 0,
            minute: 0
        },
        to: {
            day: startDay === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY ? generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SATURDAY */ .eO.SATURDAY : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DayOfWeek.SUNDAY */ .eO.SUNDAY,
            hour: 23,
            minute: 59
        }
    }, date, startDay), scheduleStart = ref.from, scheduleEnd = ref.to;
    return shifts.reduce(function(shifts, shift) {
        // All this hackery is necessary because the devexpress framework does not support "appointments" that are longer
        // than `24 hours - 1ms`.
        // Shifts rotate on a week boundary, so we determine the chunks based off of the duration to consume - that is, if
        // the shift spans more than 24 hours, we split it into consecutive chunks.
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        // If DST starts during the span in the following week, make sure we use the end timezone rather than the following
        // week's when we circle back to the beginning.
        var endDateOffset = scheduleEnd.getTime() < endDate.getTime() ? scheduleEnd.getTimezoneOffset() : endDate.getTimezoneOffset();
        // We shift to local time to utilize modulus rings targetting 24 hours. This should also reveal any DST
        // changes. However, we use the calendar boundary if end spans into the following week.
        var shiftedStartDate = new Date(startDate.getTime() - startDate.getTimezoneOffset() * 1..minutes);
        var shiftedEndDate = new Date(endDate.getTime() - endDateOffset * 1..minutes);
        var startSplit = shiftedStartDate.getTime();
        var durationToConsume = shiftedEndDate.getTime() - shiftedStartDate.getTime();
        while(0 < durationToConsume){
            // Subtract one to avoid extending into the following day - it's added back when subtracting the duration.
            var dayEnd = Math.ceil((startSplit + 1) / 24..hours) * 24..hours - 1;
            var startTimeOffset = new Date(startSplit).getTimezoneOffset() * 1..minutes;
            var partStartDate = new Date(startSplit + startTimeOffset);
            var timeTillMidnight = dayEnd - startSplit;
            var partEndDate = new Date(partStartDate.getTime() + Math.min(durationToConsume, timeTillMidnight));
            shifts.push({
                title: shift.name,
                id: shift.id,
                startDate: partStartDate,
                endDate: partEndDate,
                originalShift: shift
            });
            durationToConsume -= partEndDate.getTime() - partStartDate.getTime() + 1;
            // We don't need to shift the scheduleStart, since it's cancelled out after the rotation.
            startSplit = scheduleStart.getTime() + (startSplit - scheduleStart.getTime() + timeTillMidnight + 1) % 7..days;
        }
        return shifts;
    }, []);
};
var ref, ref1;
/**
 * We remap the whole schedule, to avoid all `__typename` fields.
 */ var unrollSchedule = function(schedule) {
    return {
        lineId: schedule === null || schedule === void 0 ? void 0 : schedule.lineId,
        validFrom: {
            year: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.year,
            week: schedule === null || schedule === void 0 ? void 0 : schedule.validFrom.week
        },
        isExceptionalWeek: (ref = schedule === null || schedule === void 0 ? void 0 : schedule.isExceptionalWeek) !== null && ref !== void 0 ? ref : false,
        shifts: ((ref1 = schedule === null || schedule === void 0 ? void 0 : schedule.shifts) !== null && ref1 !== void 0 ? ref1 : []).map(function(shift) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            return {
                id: shift.id,
                name: shift.name,
                description: shift.description,
                targets: {
                    oee: shift === null || shift === void 0 ? void 0 : (ref = shift.targets) === null || ref === void 0 ? void 0 : ref.oee,
                    oee2: shift === null || shift === void 0 ? void 0 : (ref1 = shift.targets) === null || ref1 === void 0 ? void 0 : ref1.oee2,
                    oee3: shift === null || shift === void 0 ? void 0 : (ref2 = shift.targets) === null || ref2 === void 0 ? void 0 : ref2.oee3,
                    tcu: shift === null || shift === void 0 ? void 0 : (ref3 = shift.targets) === null || ref3 === void 0 ? void 0 : ref3.tcu,
                    produced: shift === null || shift === void 0 ? void 0 : (ref4 = shift.targets) === null || ref4 === void 0 ? void 0 : ref4.produced,
                    numberOfBatches: shift === null || shift === void 0 ? void 0 : (ref5 = shift.targets) === null || ref5 === void 0 ? void 0 : ref5.numberOfBatches
                },
                timeRange: {
                    from: {
                        day: shift === null || shift === void 0 ? void 0 : (ref6 = shift.timeRange) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.from) === null || ref7 === void 0 ? void 0 : ref7.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref8 = shift.timeRange) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.from) === null || ref9 === void 0 ? void 0 : ref9.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref10 = shift.timeRange) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.from) === null || ref11 === void 0 ? void 0 : ref11.minute
                    },
                    to: {
                        day: shift === null || shift === void 0 ? void 0 : (ref12 = shift.timeRange) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.to) === null || ref13 === void 0 ? void 0 : ref13.day,
                        hour: shift === null || shift === void 0 ? void 0 : (ref14 = shift.timeRange) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.to) === null || ref15 === void 0 ? void 0 : ref15.hour,
                        minute: shift === null || shift === void 0 ? void 0 : (ref16 = shift.timeRange) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.to) === null || ref17 === void 0 ? void 0 : ref17.minute
                    }
                }
            };
        })
    };
};
var getShiftFromShifts = function(shifts, date, startDay, options) {
    var target = (options === null || options === void 0 ? void 0 : options.target) || "current";
    // Bipolar offset, i.e.: -1, 0, 1
    var indexOffset = +(target === "previous") || -(target === "next");
    var sortedShifts = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(shifts).sort(function(a, b) {
        var ref = convertGenericShiftTimeToDatePair(a.timeRange, date, startDay), dateA = ref.to;
        var ref1 = convertGenericShiftTimeToDatePair(b.timeRange, date, startDay), dateB = ref1.to;
        return dateA.getTime() - dateB.getTime();
    });
    var restructuredShifts = sortedShifts.map(function(shift) {
        var ref = convertGenericShiftTimeToDatePair(shift.timeRange, date, startDay), startDate = ref.from, endDate = ref.to;
        return {
            shift: shift,
            startDate: startDate,
            endDate: endDate
        };
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(restructuredShifts.slice(restructuredShifts.length - 1), 1), lastShift = ref[0];
    if (!lastShift) {
        return;
    }
    if ((lastShift.endDate.getDay() || 7) < (lastShift.startDate.getDay() || 7)) {
        restructuredShifts.unshift({
            shift: lastShift.shift,
            startDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.startDate, 7),
            endDate: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(lastShift.endDate, 7)
        });
    }
    var index = restructuredShifts.reverse().findIndex(function(param) {
        var startDate = param.startDate;
        return startDate <= date;
    });
    return restructuredShifts[index + indexOffset];
};
var getWeekdayNumberSane = function(dayOfWeek) {
    switch(dayOfWeek){
        case "MONDAY":
            return 0;
        case "TUESDAY":
            return 1;
        case "WEDNESDAY":
            return 2;
        case "THURSDAY":
            return 3;
        case "FRIDAY":
            return 4;
        case "SATURDAY":
            return 5;
        case "SUNDAY":
            return 6;
        default:
            return 0;
    }
};
var shiftDuration = function(timeRange) {
    var _from = timeRange.from, fromDayEnum = _from.day, fromHour = _from.hour, fromMinute = _from.minute, _to = timeRange.to, toDayEnum = _to.day, toHour = _to.hour, toMinute = _to.minute;
    // NOTE: Shift it by one day, just to make sure we don't end up at a zero-day
    // (1970-01-00)
    var fromDay = getWeekdayNumberSane(fromDayEnum) + 1;
    var toDay = getWeekdayNumberSane(toDayEnum) + 1;
    if (toDay < fromDay) {
        toDay += 7;
    }
    var fromTimestamp = new Date([
        "1970-01-",
        [
            fromDay,
            fromHour,
            fromMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    var toTimestamp = new Date([
        "1970-01-",
        [
            toDay,
            toHour,
            toMinute
        ].map(function(part) {
            return part.toLocaleString(undefined, {
                minimumIntegerDigits: 2
            });
        }).join(":").replace(":", "T"),
        ":00.000Z", 
    ].join("")).getTime();
    return toTimestamp - fromTimestamp;
};


/***/ }),

/***/ 98156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withIAM; },
/* harmony export */   "y": function() { return /* binding */ withIAMPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95885);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98021);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34375);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(89879);
/* harmony import */ var _contexts_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46036);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(5887);
/* harmony import */ var _hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12872);
/* harmony import */ var _lib_features__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53541);





















// FIXME: Correct the user context signature...
// tslint:disable:max-classes-per-file
var withIAM = function(WrappedComponent) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMWrapper, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMWrapper);
        function WithIAMWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithIAMWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                children: function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        user: user,
                        features: user.features,
                        hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                        hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                        hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                        hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                        hasFeatureInAnyUserPool: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features),
                        hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                    }, _this.props));
                }
            });
        };
        return WithIAMWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};
var styles = function(theme) {
    return {
        card: {
            width: "100%",
            maxWidth: "500px"
        },
        fillHeight: {
            height: "100%"
        },
        title: {
            marginBottom: theme.spacing(2)
        }
    };
};
var withIAMPage = function(lookupFeatures, featureType) {
    var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "group";
    return function(WrappedComponent) {
        var WithIAMPageWrapper = /*#__PURE__*/ function(_Component) {
            "use strict";
            (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMPageWrapper, _Component);
            var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMPageWrapper);
            function WithIAMPageWrapper() {
                (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMPageWrapper);
                return _super.apply(this, arguments);
            }
            var _proto = WithIAMPageWrapper.prototype;
            _proto.render = function render() {
                var _props = this.props, classes = _props.classes, t = _props.t, i18n = _props.i18n, tReady = _props.tReady, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_props, [
                    "classes",
                    "t",
                    "i18n",
                    "tReady"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                    children: function(_param) {
                        var status = _param.status, user = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
                            "status"
                        ]);
                        var allowed = scope === "userPool" ? _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)(lookupFeatures, featureType) : _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)(lookupFeatures, featureType);
                        var wrappedMessage;
                        if (!status.loading && user && user.features && !allowed) {
                            wrappedMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                className: classes.fillHeight,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    className: classes.fillHeight,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.card,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "h5",
                                                            className: classes.title,
                                                            children: t([
                                                                "shared:unfortunatelyNoPermission"
                                                            ], {
                                                                defaultValue: "Unfortunately, you don't have permission to view this page!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            children: t([
                                                                "shared:contactYourLocalAdminIfWrong"
                                                            ], {
                                                                defaultValue: "If you believe this is a mistake, contact your local administrator, and they can grant you access."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_blackbird_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                        href: {
                                                            pathname: "/"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            color: "primary",
                                                            children: t([
                                                                "shared:returnToFrontPage"
                                                            ], {
                                                                defaultValue: "Return to front page"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            loading: status.loading,
                            error: status.error,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                features: user.features,
                                hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                                hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                                hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                                hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                                hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                            }, restProps))
                        });
                    }
                });
            };
            return WithIAMPageWrapper;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_19__/* .withTranslation */ .Z)([
            "shared"
        ]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__/* .withStyles */ .D)(styles));
        return enhance(WithIAMPageWrapper);
    };
};


/***/ }),

/***/ 41440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ withLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _contexts_line__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89506);







// tslint:disable:max-classes-per-file
var withLine = function(WrappedComponent) {
    return /*#__PURE__*/ function(_PureComponent) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(WithLineWrapper, _PureComponent);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(WithLineWrapper);
        function WithLineWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, WithLineWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithLineWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_line__WEBPACK_IMPORTED_MODULE_5__/* .LineContext.Consumer */ .t.Consumer, {
                children: function(param) {
                    var lineId = param.lineId, lineName = param.lineName;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        lineId: lineId,
                        lineName: lineName
                    }, _this.props));
                }
            });
        };
        return WithLineWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
};


/***/ }),

/***/ 81861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ withUtils; },
/* harmony export */   "n": function() { return /* binding */ useUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14478);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54765);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28879);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84984);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25655);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68568);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84358);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36712);







var additionalUtils = function(locale) {
    return {
        formatDistance: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatDistanceStrict: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatRelative: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatWeekdays: function(formatString) {
            var now = new Date();
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                start: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                }),
                end: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                })
            }).map(function(day) {
                return (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(day, formatString, {
                    locale: locale
                });
            });
        }
    };
};
var useUtils = function() {
    var utils = new _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    return Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")));
};
var withUtils = function(WrappedComponent) {
    return function(props) {
        var utils = useUtils();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            utils: Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")))
        }));
    };
};


/***/ }),

/***/ 19742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ lines; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@3009f328dedb95f506d4c1ef31f9c96184304370_@emotion+react_l3yjjrk752jqo5q45jlioom6ka/node_modules/@blackbird/ui-base/dist/es/index.js + 17 modules
var es = __webpack_require__(95885);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(61431);
// EXTERNAL MODULE: ./views/lines/overview-components/menu.tsx + 1 modules
var menu = __webpack_require__(69246);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(88802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(54524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(78344);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(66637);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(13515);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(25998);
// EXTERNAL MODULE: ./components/buttons/sticky-fab.tsx
var sticky_fab = __webpack_require__(4228);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(94167);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(67844);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(30509);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(26561);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Step/Step.js
var Step = __webpack_require__(77801);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/StepLabel/StepLabel.js
var StepLabel = __webpack_require__(41292);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Stepper/Stepper.js
var Stepper = __webpack_require__(99158);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(60840);
// EXTERNAL MODULE: ./components/loading/overlay-spinner.tsx
var overlay_spinner = __webpack_require__(59967);
// EXTERNAL MODULE: ./graphql/mutations/line-create.gql
var line_create = __webpack_require__(65868);
var line_create_default = /*#__PURE__*/__webpack_require__.n(line_create);
// EXTERNAL MODULE: ./graphql/queries/sensor-groups.gql
var sensor_groups = __webpack_require__(18828);
var sensor_groups_default = /*#__PURE__*/__webpack_require__.n(sensor_groups);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(52108);
// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/line-list-topology.tsx + 1 modules
var line_list_topology = __webpack_require__(30182);
// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/select-sensor.tsx
var select_sensor = __webpack_require__(3911);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(16066);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(74110);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(33804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(67815);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Radio/Radio.js + 3 modules
var Radio = __webpack_require__(9734);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(35458);
// EXTERNAL MODULE: ./hooks/use-iam.tsx
var use_iam = __webpack_require__(12872);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/select-sensor-group.tsx























var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        content: {
            flexWrap: "wrap"
        },
        divider: {
            height: "5px",
            margin: "30px 0"
        },
        groupItem: {
            marginLeft: "0px",
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row"
        },
        accordion: {
            flex: "1",
            transition: "box-shadow .25s",
            "&:hover": {
                cursor: "pointer",
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        accordionDisabled: {
            color: "grey",
            backgroundColor: "#d3d3d3",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            },
            flex: "auto"
        },
        cardEmpty: {
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        sensorChip: (_obj = {
            margin: theme.spacing(0.5),
            color: "#000000"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            maxWidth: "100px"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            maxWidth: "200px"
        }), _obj),
        lineTakenExplanation: {
            marginBottom: theme.spacing()
        },
        radioButton: {
            paddingLeft: "0"
        }
    };
});
var SelectSensorGroup = function(param) {
    var selectedGroup = param.selectedGroup, onSelectSensorGroup = param.onSelectSensorGroup;
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var iam = (0,use_iam/* useIAM */.e)();
    var width = (0,use_width/* useWidth */.z)();
    var ref1 = (0,react.useState)([]), groups = ref1[0], setGroups = ref1[1];
    var ref2 = (0,react.useState)([]), enabledGroups = ref2[0], setEnabledGroups = ref2[1];
    var ref3 = (0,react.useState)([]), disabledGroups = ref3[0], setDisabledGroups = ref3[1];
    var ref4 = (0,react.useState)([]), emptyGroups = ref4[0], setEmptyGroups = ref4[1];
    var ref5 = (0,react.useState)(false), expandedGroup = ref5[0], setExpandedGroup = ref5[1];
    var ref6 = (0,client.useQuery)((sensor_groups_default()), {
        partialRefetch: true,
        ssr: false,
        errorPolicy: "all",
        onCompleted: function(res) {
            return setGroups(res.company.groups.map(function(group) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, group), {
                    availableSensors: group.sensors.filter(function(s) {
                        return s && !sensorIsPartOfLine(s);
                    }),
                    unavailableSensors: group.sensors.filter(function(s) {
                        return s && sensorIsPartOfLine(s);
                    })
                });
            }));
        }
    }), data = ref6.data, loading = ref6.loading, error = ref6.error;
    (0,react.useEffect)(function() {
        if (groups.length === 0) {
            return;
        }
        var sortedGroups = sortGroupsByName(groups);
        var filteredGroups = sortedGroups.filter(function(group) {
            return iam.hasGroupFeatures(group.id, [
                "Lines.Line",
                "Lines.Group"
            ], "M");
        });
        var newEnabledGroups = filteredGroups.filter(function(group) {
            var ref;
            return 0 < (((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) || 0);
        });
        var newDisabledGroups = filteredGroups.filter(function(group) {
            var ref, ref1;
            return ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0;
        });
        var newEmptyGroups = filteredGroups.filter(function(group) {
            var ref, ref1;
            return ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) === 0;
        });
        setEnabledGroups(newEnabledGroups);
        setDisabledGroups(newDisabledGroups);
        setEmptyGroups(newEmptyGroups);
        if (newEnabledGroups.length > 0 && !(width === "sm" || width === "xs")) {
            setExpandedGroup(newEnabledGroups[0].id);
        }
    }, [
        groups
    ]);
    if (!data || !data.company || !data.company.groups) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
            loading: loading,
            error: error
        });
    }
    var onSelectGroup = function(group) {
        onSelectSensorGroup((selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id) === group.id ? null : group);
    };
    var renderSensorGroup = function(group) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SensorGroup, {
            group: group,
            selectedGroupId: selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id,
            expandedGroupId: expandedGroup,
            onSelectGroup: onSelectGroup,
            onExpandedChange: function(newExpandedGroup) {
                return setExpandedGroup(newExpandedGroup);
            }
        }, "group-".concat(group.id));
    };
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
            loading: loading
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "caption",
                className: classes.lineTakenExplanation,
                display: "block",
                children: [
                    t([
                        "line:explanationLinesLikeTheFollowing"
                    ], {
                        defaultValue: "Sensors looking like the following:"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            children: t([
                                "line:sensorName"
                            ], {
                                defaultValue: "Sensor name"
                            }).toLowerCase()
                        }),
                        color: "default"
                    }),
                    " ",
                    t([
                        "line:explanationAlreadyTaken"
                    ], {
                        defaultValue: ", are already part of a line, and cannot be added to a new one."
                    })
                ]
            }),
            enabledGroups.map(renderSensorGroup),
            disabledGroups.map(renderSensorGroup),
            emptyGroups.map(renderSensorGroup)
        ]
    });
};
var SensorGroup = function(props) {
    var ref, ref1, ref2, ref3;
    var group = props.group, selectedGroupId = props.selectedGroupId, expandedGroupId = props.expandedGroupId, onSelectGroup = props.onSelectGroup, onExpandedChange = props.onExpandedChange;
    var classes = useStyles().classes;
    var groupIsDisabled = ((ref = group.availableSensors) === null || ref === void 0 ? void 0 : ref.length) === 0 && ((ref1 = group.unavailableSensors) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0;
    var groupIsEmpty = ((ref2 = group.availableSensors) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 && ((ref3 = group.unavailableSensors) === null || ref3 === void 0 ? void 0 : ref3.length) === 0;
    var onAccordionChange = function(groupId) {
        return function(event, isExpanded) {
            onExpandedChange(isExpanded ? groupId : false);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.groupItem,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                onClick: function() {
                    return onSelectGroup(group);
                },
                disabled: groupIsDisabled || groupIsEmpty,
                checked: selectedGroupId === group.id,
                color: "primary",
                className: classes.radioButton
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                elevation: 3,
                expanded: expandedGroupId === group.id,
                onChange: onAccordionChange(group.id),
                className: groupIsDisabled || groupIsEmpty ? classes.accordionDisabled : classes.accordion,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                        "aria-controls": "panel1bh-content",
                        id: "panel1bh-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "".concat(group.name, " ").concat(groupIsDisabled || groupIsEmpty ? " - " + " no available sensors " : "")
                        })
                    }, "summary-" + group.id),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        className: classes.content,
                        onClick: function() {
                            return onSelectGroup(group);
                        },
                        children: groupIsEmpty ? null : sortSensorByAvailability(group.sensors.filter(helper_types/* isTruthy */.f)).map(function(sensor) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SensorItem, {
                                sensor: sensor,
                                groupName: group.name
                            }, "sensor-".concat(sensor.peripheralId));
                        })
                    }, "details-" + group.id)
                ]
            }, "accordion-" + group.id)
        ]
    }, "div-" + group.id);
};
var SensorItem = function(props) {
    var sensor = props.sensor, groupName = props.groupName;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var classes = useStyles().classes;
    if (!sensor) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        placement: "top",
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: sensor.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                sensor.description,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                sensorIsPartOfLine(sensor) ? t([
                    "line:partOfLine"
                ], {
                    defaultValue: "Part of line"
                }) : t([
                    "shared:available"
                ], {
                    defaultValue: "Available"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
            label: sensor.name,
            variant: sensorIsPartOfLine(sensor) ? "filled" : "outlined",
            color: sensorIsPartOfLine(sensor) ? "default" : "primary",
            className: classes.sensorChip
        }, groupName + sensor.name)
    }, "".concat(groupName, "-select-sensor-group-").concat(sensor.name, "-").concat(sensor.peripheralId));
};
var sensorIsPartOfLine = function(sensor) {
    var ref, ref1;
    return !!(sensor === null || sensor === void 0 ? void 0 : (ref = sensor.peripheralInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.peripheralId);
};
var sortGroupsByName = function(groups) {
    var sortedGroups = (0,_to_consumable_array/* default */.Z)(groups);
    sortedGroups.sort(function(group1, group2) {
        return group1.name.localeCompare(group2.name);
    });
    return sortedGroups;
};
var sortSensorByAvailability = function(sensors) {
    var sortedSensors = (0,_to_consumable_array/* default */.Z)(sensors);
    sortedSensors.sort(function(sensor1, sensor2) {
        if (sensorIsPartOfLine(sensor1) && !sensorIsPartOfLine(sensor2)) {
            return 1;
        } else if (!sensorIsPartOfLine(sensor1) && sensorIsPartOfLine(sensor2)) {
            return -1;
        } else {
            return (sensor1 === null || sensor1 === void 0 ? void 0 : sensor1.name.localeCompare((sensor2 === null || sensor2 === void 0 ? void 0 : sensor2.name) || "")) || 0;
        }
    });
    return sortedSensors;
};
/* harmony default export */ var select_sensor_group = (SelectSensorGroup);

// EXTERNAL MODULE: ./views/dialogs/line-settings/setup-line/specify-line-info.tsx
var specify_line_info = __webpack_require__(17649);
;// CONCATENATED MODULE: ./components/dialogs/create-line/create-line-dialog.tsx































var create_line_dialog_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        step: {
            maxHeight: "80px"
        },
        stepper: {
            maxHeight: "90px",
            paddingTop: "0px",
            paddingBottom: "10px"
        },
        stepContent: {
            flexGrow: 1
        },
        backButton: {
            marginRight: theme.spacing()
        },
        dialogSize: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            minWidth: "100% !important",
            minHeight: "100%"
        }),
        dialogBackgroundColor: {
            backgroundColor: "#fafafa",
            outlineStyle: "none"
        }
    };
});
var CreateLineDialog = function(param) {
    var handleOpenClose = param.handleOpenClose, open = param.open;
    var classes = create_line_dialog_useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = (0,react.useState)(0), activeStep = ref1[0], setActiveStep = ref1[1];
    var ref2 = (0,react.useState)(null), sensorGroup = ref2[0], setSensorGroup = ref2[1];
    var ref3 = (0,react.useState)(null), bottleneckSensor = ref3[0], setBottleneckSensor = ref3[1];
    var ref4 = (0,react.useState)([]), nodes = ref4[0], setNodes = ref4[1];
    var ref5 = (0,react.useState)([]), links = ref5[0], setLinks = ref5[1];
    var ref6 = (0,react.useState)({
        name: "",
        description: ""
    }), lineInfo = ref6[0], setLineInfo = ref6[1];
    var ref7 = (0,react.useState)(true), nextButtonDisabled = ref7[0], setNextButtonDisabled = ref7[1];
    var steps = [
        t([
            "line:selectSensorGroup"
        ], {
            defaultValue: "Select a sensor group"
        }),
        t([
            "line:createLine"
        ], {
            defaultValue: "Create line"
        }),
        t([
            "line:describeLineTopology"
        ], {
            defaultValue: "Line composition (optional)"
        }),
        t([
            "line:lineSetupFinished"
        ], {
            defaultValue: "Finished line setup"
        }), 
    ];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((line_create_default())), 2), createLine = ref8[0], loading = ref8[1].loading;
    (0,react.useEffect)(function() {
        if (activeStep === 0) {
            resetState();
        }
    }, [
        activeStep
    ]);
    (0,react.useEffect)(function() {
        var disabled = true;
        switch(activeStep){
            case 0:
                disabled = !sensorGroup;
                break;
            case 1:
                disabled = !(bottleneckSensor && lineInfo.name);
                break;
            case 2:
                disabled = false;
                break;
            case 3:
                disabled = true;
                break;
            default:
                console.error("Unrecognized step! Value: " + activeStep + " Type: " + (typeof activeStep === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(activeStep)));
                break;
        }
        setNextButtonDisabled(disabled);
    }, [
        activeStep,
        sensorGroup,
        bottleneckSensor,
        lineInfo
    ]);
    (0,react.useEffect)(function() {
        if (bottleneckSensor && !nodes.find(function(node) {
            return node.peripheralId === bottleneckSensor.peripheralId;
        })) {
            var newGraphNode = {
                sensorName: bottleneckSensor.name,
                sensorDescription: bottleneckSensor.description,
                peripheralId: bottleneckSensor.peripheralId,
                nodeType: schema/* NodeType.Main */.Jq.Main,
                sensorType: bottleneckSensor.config.type,
                registerStops: true,
                oee: true
            };
            setNodes((0,_to_consumable_array/* default */.Z)(nodes).concat([
                newGraphNode
            ]));
        }
    }, [
        bottleneckSensor
    ]);
    var resetState = function() {
        setSensorGroup(null);
        setBottleneckSensor(null);
        setNodes([]);
        setLinks([]);
        setLineInfo({
            name: "",
            description: ""
        });
        setNextButtonDisabled(true);
    };
    var handleBack = function() {
        if (activeStep === 0) {
            return;
        }
        setActiveStep(activeStep - 1);
    };
    var handleClose = function() {
        setActiveStep(0);
        handleOpenClose(false);
    };
    var handleNext = function() {
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(activeStep === steps.length - 2)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            submitFinishedLine()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setActiveStep(activeStep + 1);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    var submitFinishedLine = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!sensorGroup) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            createLine({
                                refetchQueries: [
                                    {
                                        query: (sensor_groups_default())
                                    }
                                ],
                                variables: {
                                    groupId: sensorGroup.id,
                                    name: lineInfo.name,
                                    description: (lineInfo === null || lineInfo === void 0 ? void 0 : lineInfo.description) || "",
                                    nodes: nodes.map(function(node) {
                                        return {
                                            peripheralId: node.peripheralId,
                                            type: node.nodeType
                                        };
                                    }),
                                    edges: links.map(function(link) {
                                        return {
                                            from: link.source,
                                            to: link.target
                                        };
                                    })
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        setActiveStep(activeStep + 1);
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFinishedLine() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderActionButtons = function() {
        var backButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: handleBack,
            className: classes.backButton,
            children: t([
                "shared:back"
            ], {
                defaultValue: "Back"
            })
        });
        var nextButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            disabled: nextButtonDisabled,
            color: "primary",
            onClick: handleNext(),
            children: t([
                "shared:next"
            ], {
                defaultValue: "Next"
            })
        });
        var finishButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            color: "primary",
            onClick: handleNext(),
            children: t([
                "shared:finish"
            ], {
                defaultValue: "Finish"
            })
        });
        switch(activeStep){
            case 0:
                return nextButton;
            case 1:
                return [
                    backButton,
                    nextButton
                ];
            case 2:
                return [
                    backButton,
                    finishButton
                ];
            case 3:
                return null;
            default:
                console.error("Unknown step index!");
        }
    };
    var sensorTypeToNodeType = function(sensorType) {
        if (!sensorType) {
            return schema/* NodeType.Counter */.Jq.Counter;
        }
        switch(sensorType){
            case schema/* SensorType.COUNTER */.dE.COUNTER:
            case schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE:
            case schema/* SensorType.COUNTER_SPEED */.dE.COUNTER_SPEED:
            case schema/* SensorType.DISCRETE */.dE.DISCRETE:
            case schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS:
            case schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT:
                return schema/* NodeType.Counter */.Jq.Counter;
            case schema/* SensorType.EVENT */.dE.EVENT:
                return schema/* NodeType.Event */.Jq.Event;
            default:
                console.warn("Unrecognized sensor type!");
                return schema/* NodeType.Counter */.Jq.Counter;
        }
    };
    var onSelectSensorWithLineSettings = function(sensor) {
        var isCamera = sensor.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA;
        var existingSensorNode = nodes.find(function(node) {
            return node.peripheralId === sensor.peripheralId;
        });
        var id = existingSensorNode === null || existingSensorNode === void 0 ? void 0 : existingSensorNode.peripheralId;
        if (existingSensorNode && existingSensorNode.nodeType !== schema/* NodeType.Main */.Jq.Main) {
            var updatedNodes = nodes.filter(function(node) {
                return node.peripheralId !== id;
            });
            var updatedLinks = links.filter(function(link) {
                return link.source !== id && link.target !== id;
            });
            setNodes(updatedNodes);
            setLinks(updatedLinks);
        } else if (!nodes.some(function(node) {
            return node.peripheralId === sensor.peripheralId;
        })) {
            var newGraphNode = {
                sensorName: sensor.name,
                sensorDescription: sensor.description,
                peripheralId: sensor.peripheralId,
                sensorType: sensor.config.type,
                nodeType: isCamera ? schema/* NodeType.Camera */.Jq.Camera : sensorTypeToNodeType(sensor.config.type),
                registerStops: false,
                oee: false
            };
            setNodes((0,_to_consumable_array/* default */.Z)(nodes).concat([
                newGraphNode
            ]));
        }
    };
    var onAddSensorNode = function(peripheralId, isBeforeMain) {
        var updatedLinks = (0,_to_consumable_array/* default */.Z)(links);
        var source = isBeforeMain ? peripheralId : bottleneckSensor.peripheralId;
        var target = isBeforeMain ? bottleneckSensor.peripheralId : peripheralId;
        updatedLinks.push({
            source: source,
            target: target
        });
        setLinks(updatedLinks);
    };
    var onRemoveSensorNode = function(peripheralId) {
        var updatedLinks = links.filter(function(link) {
            return link.source !== peripheralId && link.target !== peripheralId;
        });
        setLinks(updatedLinks);
    };
    var onSelectBottleneckSensor = function(sensor) {
        var matchingNode = nodes.find(function(node) {
            return node.peripheralId === (bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId);
        });
        if (matchingNode) {
            var filteredNodes = (0,_to_consumable_array/* default */.Z)(nodes.filter(function(node) {
                return node.peripheralId !== matchingNode.peripheralId;
            }));
            setNodes(filteredNodes);
        }
        setBottleneckSensor(sensor);
    };
    var getStepContent = function() {
        switch(activeStep){
            case 0:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor_group, {
                    selectedGroup: sensorGroup,
                    onSelectSensorGroup: setSensorGroup
                });
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    alignItems: "stretch",
                    justifyContent: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specify_line_info/* default */.Z, {
                                lineInfo: lineInfo,
                                onChangeLineInfo: setLineInfo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                                title: t([
                                    "line:selectBottleneckCounter"
                                ], {
                                    defaultValue: "Select the bottleneck sensor of the line"
                                }) + "*",
                                disabledSensorId: undefined,
                                sensors: ((sensorGroup === null || sensorGroup === void 0 ? void 0 : sensorGroup.availableSensors) || []).filter(helper_types/* isTruthy */.f),
                                selectedSensorIds: bottleneckSensor ? [
                                    bottleneckSensor.peripheralId
                                ] : [],
                                onSelectSensor: onSelectBottleneckSensor,
                                selectDefault: true
                            })
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t([
                                "line:addRemainingSensors"
                            ], {
                                defaultValue: "To get complete overview of your line, please add any remaining sensors"
                            })
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(select_sensor/* default */.Z, {
                            disabledSensorId: bottleneckSensor === null || bottleneckSensor === void 0 ? void 0 : bottleneckSensor.peripheralId,
                            title: t([
                                "line:selectOtherSensors"
                            ], {
                                defaultValue: "Select all additional sensors on line"
                            }) + " " + lineInfo.name,
                            selectedSensorIds: nodes.map(function(node) {
                                return node.peripheralId;
                            }),
                            sensors: ((sensorGroup === null || sensorGroup === void 0 ? void 0 : sensorGroup.availableSensors) || []).filter(helper_types/* isTruthy */.f),
                            onSelectSensor: onSelectSensorWithLineSettings
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(line_list_topology/* default */.Z, {
                            // Only non-bottleneck and counter sensors can be scrap
                            availableNodes: nodes.filter(function(node) {
                                return node.nodeType !== schema/* NodeType.Main */.Jq.Main && (node.sensorType === schema/* SensorType.COUNTER */.dE.COUNTER || node.sensorType === schema/* SensorType.COUNTER_ACCUMULATE */.dE.COUNTER_ACCUMULATE);
                            }),
                            mainSensorNodeName: bottleneckSensor.name,
                            mainSensorNodePeripheralId: bottleneckSensor.peripheralId,
                            nodeLinks: links,
                            onAddScrapSensor: onAddSensorNode,
                            onRemoveScrapSensor: onRemoveSensorNode
                        })
                    ]
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sx: {
                            textAlign: "center",
                            maxWidth: "500px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: t([
                                "line:creationDelayExplanation"
                            ], {
                                defaultValue: "It might take up to 5 minutes for the line to appear in the Lines Overview. Try refreshing the page after closing this dialog."
                            })
                        })
                    })
                });
            default:
                return "Unknown stepIndex";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        maxWidth: false,
        open: open,
        onClose: handleClose,
        PaperProps: {
            className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.dialogSize),
            style: {
                display: "flex",
                flexDirection: "column"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: steps[activeStep],
                onClose: handleClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
                activeStep: activeStep,
                alternativeLabel: true,
                className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.stepper),
                children: steps.map(function(label, i) {
                    if (i === steps.length - 1) {
                        // We deliberately don't want to show the finish page as a step.
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step/* default */.Z, {
                        className: classes.step,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabel/* default */.Z, {
                            children: label
                        })
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                className: "".concat(classes.dialogBackgroundColor, " ").concat(classes.stepContent),
                children: getStepContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                className: classes.dialogBackgroundColor,
                children: renderActionButtons()
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(overlay_spinner/* default */.Z, {}) : null
        ]
    });
};

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(35606);
// EXTERNAL MODULE: ./graphql/queries/lines-list-simple.gql
var lines_list_simple = __webpack_require__(16450);
var lines_list_simple_default = /*#__PURE__*/__webpack_require__.n(lines_list_simple);
// EXTERNAL MODULE: ./hocs/with-line.tsx
var with_line = __webpack_require__(41440);
// EXTERNAL MODULE: ./hocs/with-iam.tsx
var with_iam = __webpack_require__(98156);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(74782);
// EXTERNAL MODULE: ./views/lines/overview-cards.tsx + 7 modules
var overview_cards = __webpack_require__(3803);
// EXTERNAL MODULE: ./components/bars/overview-top-bar.tsx + 1 modules
var overview_top_bar = __webpack_require__(19536);
;// CONCATENATED MODULE: ./views/lines/overview-top-bar.tsx




var LinesTopBar = function(param) {
    var search = param.search, page = param.page, filteredLines = param.filteredLines, pageSize = param.pageSize, cardConf = param.cardConf, handlePageChange = param.handlePageChange, handleSearchChange = param.handleSearchChange, updateConf = param.updateConf, updateIntervalConf = param.updateIntervalConf, updateRefreshIntervalConf = param.updateRefreshIntervalConf, updateInterval = param.updateInterval, nextLiveUpdate = param.nextLiveUpdate;
    var suggestions = (0,react.useMemo)(function() {
        return filteredLines.filter(function(line) {
            if (!search.length) {
                return true;
            }
            if (!(line === null || line === void 0 ? void 0 : line.name)) {
                return false;
            }
            return search.some(function(searchTerm) {
                return [
                    line.name.toLowerCase(),
                    (line.description || "").toLowerCase()
                ].some(function(entry) {
                    var ref;
                    return (searchTerm === null || searchTerm === void 0 ? void 0 : (ref = searchTerm.value) === null || ref === void 0 ? void 0 : ref.value) && entry.includes(searchTerm.value.value);
                });
            });
        }).map(function(line) {
            var label = line.name || line.description;
            return {
                label: label,
                value: {
                    type: "string",
                    value: label.toLowerCase()
                }
            };
        });
    }, [
        filteredLines,
        search
    ]);
    var totalCount = filteredLines.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_top_bar/* default */.Z, {
        search: search,
        suggestions: suggestions,
        page: page,
        pageSize: pageSize,
        totalCount: totalCount,
        handlePageChange: handlePageChange,
        handleSearchChange: handleSearchChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.ZP, {
            cardConf: cardConf,
            updateConf: updateConf,
            updateIntervalConf: updateIntervalConf,
            updateInterval: updateInterval,
            updateRefreshIntervalConf: updateRefreshIntervalConf,
            nextLiveUpdate: nextLiveUpdate
        })
    });
};
/* harmony default export */ var lines_overview_top_bar = (LinesTopBar);

;// CONCATENATED MODULE: ./views/lines/overview-page.tsx































var styles = function(theme) {
    return {
        button: {
            position: "absolute",
            bottom: theme.spacing(3),
            right: theme.spacing(3)
        },
        message: {
            paddingBottom: theme.spacing(2)
        },
        lightBtn: {
            color: "#fff"
        }
    };
};
/**
 * Only accept valid cache policies.
 */ function isCachePolicy(val) {
    var allowed = [
        "cache-first",
        "network-only",
        "cache-only",
        "no-cache",
        "standby",
        "cache-and-network", 
    ];
    return allowed.includes(val);
}
var LineCardPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(LineCardPage, _Component);
    var _super = (0,_create_super/* default */.Z)(LineCardPage);
    function LineCardPage(props) {
        (0,_class_call_check/* default */.Z)(this, LineCardPage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            search: [],
            page: 0,
            createModalOpen: false,
            device: "",
            cardConf: menu/* defaultCardConf */.Dx,
            kpiOptions: [],
            cachePolicy: "no-cache"
        };
        _this.pageSize = constants/* PAGE_SIZE */.IV;
        _this.filterLines = function(lines) {
            var filteredLines = lines.filter(function(line) {
                var ref;
                // If we haven't started searching yet, include all results.
                if (!((ref = _this.state.search) === null || ref === void 0 ? void 0 : ref.length)) {
                    return true;
                }
                // Filter out both results and remaining suggestions, based on the search filter.
                var foundInSearch = true;
                _this.state.search.every(function(searchTerm) {
                    if (searchTerm && searchTerm.value && searchTerm.value.value) {
                        var ref, ref1;
                        foundInSearch = ((ref = line === null || line === void 0 ? void 0 : line.name) !== null && ref !== void 0 ? ref : "").toLowerCase().includes(searchTerm.value.value.toLowerCase()) || ((ref1 = line === null || line === void 0 ? void 0 : line.description) !== null && ref1 !== void 0 ? ref1 : "").toLowerCase().includes(searchTerm.value.value.toLowerCase());
                    }
                    return Boolean(foundInSearch);
                });
                return foundInSearch;
            });
            // Sort the lines alphabetically, to always give a consistent view to the user.
            return filteredLines.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        };
        _this.getWrappedMessage = function() {
            return(// TODO: Only show this if you also have any devices. Else we should tell them to contact their local
            // administrator, like we do in devices.
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(constants/* LINE_ICON */.zN, {
                        style: {
                            height: "100px",
                            width: "100px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        className: _this.props.classes.message,
                        children: _this.props.t([
                            "line:noLinesYet"
                        ], {
                            defaultValue: "You haven't created any lines yet!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        onClick: _this.handleModalOpenClose(true),
                        className: _this.props.classes.lightBtn,
                        "aria-label": _this.props.t([
                            "shared:getStarted"
                        ], {
                            defaultValue: "Get started"
                        }),
                        children: _this.props.t([
                            "shared:getStarted"
                        ], {
                            defaultValue: "Get started"
                        })
                    })
                ]
            }));
        };
        _this.updateSessionStorage = function(newRoute) {
            // Update the session (tab specific) storage entry for navigation.
            if (typeof Storage !== "undefined") {
                window.sessionStorage.setItem(constants/* SESSION_STORAGE_LINES_NAVIGATION_OVERVIEW_SEARCH_STATE_KEY */.fs, JSON.stringify({
                    route: {
                        pathname: newRoute.pathname,
                        query: newRoute.query
                    }
                }));
            }
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePageChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this1.props.router, pathname = _router.pathname, query = _router.query;
                            _this1.setState({
                                page: page
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                page: page
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this1.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleSearchChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this2.props.router, pathname = _router.pathname, query = _router.query;
                            _this2.setState({
                                search: val,
                                page: 0
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                search: JSON.stringify(val),
                                page: 0
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this2.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleModalOpenClose = function(open) {
            return function() {
                return _this.setState({
                    createModalOpen: open
                });
            };
        };
        _this.updateConf = function(key, check) {
            _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), (0,_define_property/* default */.Z)({}, key, check))
            }, function() {
                var ref;
                // Labels can only ever be shown when stops are also enabled, so we force `showStops` to be enabled if it isn't already.
                if (key === "showStopLabels" && check && ((ref = _this.state.cardConf) === null || ref === void 0 ? void 0 : ref.showStops) === false) {
                    _this.setState({
                        cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                            showStops: true
                        })
                    });
                }
            });
        };
        _this.updateIntervalConf = function(interval) {
            return _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                    timeInterval: interval
                })
            });
        };
        _this.updateRefreshIntervalConf = function(newInterval) {
            _this.setState({
                cardConf: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this.state.cardConf), {
                    refreshInterval: newInterval
                })
            });
            _this.props.changeUpdateInterval(newInterval);
        };
        try {
            var ref, ref1;
            if (typeof Storage !== "undefined") {
                try {
                    var layoutConfiguration = JSON.parse(window.localStorage.getItem(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ));
                    if ((0,menu/* instanceOfCardConf */.Tn)(layoutConfiguration)) {
                        _this.state.cardConf = (0,_object_spread/* default */.Z)({}, _this.state.cardConf, layoutConfiguration);
                    }
                // tslint:disable-next-line:no-empty
                } catch (_) {}
            }
            if (props.router.query.search) {
                try {
                    var searchQuery = Array.isArray(props.router.query.search) ? props.router.query.search[0] : props.router.query.search;
                    _this.state.search = JSON.parse(searchQuery);
                } catch (routerError) {
                    console.error(routerError);
                }
            }
            // NOTE: We allow setting the cache policy via the URL to allow us to
            // quickly test out different caching strategies.
            if (props.router.query.cachePolicy) {
                try {
                    var cachePolicyQuery = Array.isArray(props.router.query.cachePolicy) ? props.router.query.cachePolicy[0] : props.router.query.cachePolicy;
                    if (isCachePolicy(cachePolicyQuery)) {
                        _this.state.cachePolicy = cachePolicyQuery;
                    }
                } catch (routerError1) {
                    console.error(routerError1);
                }
            }
            if (props.router.query.page) {
                try {
                    var pageQuery = Array.isArray(props.router.query.page) ? props.router.query.page[0] : props.router.query.page;
                    _this.state.page = parseInt(pageQuery, 10);
                } catch (routerError2) {
                    console.error(routerError2);
                }
            }
            if (props.router.query.action) {
                try {
                    var actionQuery = Array.isArray(props.router.query.action) ? props.router.query.action[0] : props.router.query.action;
                    _this.state.createModalOpen = actionQuery === "create";
                    delete props.router.query.action;
                } catch (routerError3) {
                    console.error(routerError3);
                }
            }
            if (props.router.query.device) {
                try {
                    var deviceQuery = Array.isArray(props.router.query.device) ? props.router.query.device[0] : props.router.query.device;
                    _this.state.device = String(deviceQuery);
                    delete props.router.query.device;
                } catch (routerError4) {
                    console.error(routerError4);
                }
            }
            var updatedQuery = (0,_object_spread/* default */.Z)({}, props.router.query);
            var url = (0,native_url.format)({
                pathname: props.router.pathname,
                query: updatedQuery
            });
            void router_default().replace(url, url, {
                shallow: true
            });
            var ref2, ref3;
            _this.updateSessionStorage({
                pathname: (ref2 = props === null || props === void 0 ? void 0 : (ref = props.router) === null || ref === void 0 ? void 0 : ref.pathname) !== null && ref2 !== void 0 ? ref2 : "/lines",
                query: (ref3 = props === null || props === void 0 ? void 0 : (ref1 = props.router) === null || ref1 === void 0 ? void 0 : ref1.query) !== null && ref3 !== void 0 ? ref3 : {}
            });
        } catch (error) {
            console.warn("\xbb Something failed in overview-page constructor, hmm...");
        }
        return _this;
    }
    var _proto = LineCardPage.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var ref, ref1, ref2, ref3;
        if (nextProps.timeAtLoad !== this.props.timeAtLoad) {
            return true;
        } else if (((ref = nextState.search) === null || ref === void 0 ? void 0 : ref.length) !== ((ref1 = this.state.search) === null || ref1 === void 0 ? void 0 : ref1.length) || nextState.page !== this.state.page || nextState.createModalOpen !== this.state.createModalOpen || nextState.cardConf !== this.state.cardConf || ((ref2 = nextState.kpiOptions) === null || ref2 === void 0 ? void 0 : ref2.length) !== ((ref3 = this.state.kpiOptions) === null || ref3 === void 0 ? void 0 : ref3.length) || !Object.keys(this.props.features.group).length && Object.keys(nextProps.features.group)) {
            return true;
        }
        return false;
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, t = _props.t, hasFeatureInAnyGroup = _props.hasFeatureInAnyGroup, timeAtLoad = _props.timeAtLoad, updateInterval = _props.updateInterval;
        var createLineFeature = hasFeatureInAnyGroup([
            "Lines.Line"
        ], "M");
        var nextLiveUpdate = null;
        if (timeAtLoad && updateInterval) {
            nextLiveUpdate = new Date(timeAtLoad.getTime() + updateInterval);
        } else if (updateInterval === null) {
            nextLiveUpdate = null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
            ssr: false,
            partialRefetch: true,
            query: (lines_list_simple_default()),
            fetchPolicy: "cache-and-network",
            errorPolicy: "all" // Necessary for returning partial data.
            ,
            children: function(param) {
                var loading = param.loading, error = param.error, data = param.data;
                var ref;
                var lines = (ref = data === null || data === void 0 ? void 0 : data.lines) !== null && ref !== void 0 ? ref : [];
                var wrappedMessage = !loading && !error && !(lines === null || lines === void 0 ? void 0 : lines.length) ? _this.getWrappedMessage() : undefined;
                // We only short-circuit the render if the query is loading or returned only an error (i.e. not an error + data).
                if (loading && !data || error && !data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lines_overview_top_bar, {
                                search: _this.state.search,
                                filteredLines: [],
                                page: _this.state.page,
                                pageSize: _this.pageSize,
                                handlePageChange: _this.handlePageChange,
                                handleSearchChange: _this.handleSearchChange,
                                cardConf: _this.state.cardConf,
                                updateConf: _this.updateConf,
                                updateIntervalConf: _this.updateIntervalConf,
                                updateRefreshIntervalConf: _this.updateRefreshIntervalConf,
                                updateInterval: updateInterval,
                                nextLiveUpdate: nextLiveUpdate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                                loading: loading,
                                error: error,
                                wrappedMessage: wrappedMessage
                            })
                        ]
                    });
                }
                var filteredLines = _this.filterLines(lines);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lines_overview_top_bar, {
                            search: _this.state.search,
                            filteredLines: filteredLines,
                            page: _this.state.page,
                            pageSize: _this.pageSize,
                            handlePageChange: _this.handlePageChange,
                            handleSearchChange: _this.handleSearchChange,
                            cardConf: _this.state.cardConf,
                            updateConf: _this.updateConf,
                            updateIntervalConf: _this.updateIntervalConf,
                            updateRefreshIntervalConf: _this.updateRefreshIntervalConf,
                            updateInterval: updateInterval,
                            nextLiveUpdate: nextLiveUpdate
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: loading,
                            error: error,
                            data: data,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 1,
                                alignItems: "stretch",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_cards/* default */.Z, {
                                        filteredLines: filteredLines,
                                        currentPage: _this.state.page,
                                        pageSize: _this.pageSize,
                                        timeAtLoad: timeAtLoad,
                                        cardConf: _this.state.cardConf,
                                        cachePolicy: _this.state.cachePolicy
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        container: true,
                                        xs: 12,
                                        direction: "row-reverse",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                                mdUp: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                                        totalPages: Math.ceil(filteredLines.length / _this.pageSize),
                                                        currentPage: _this.state.page,
                                                        onCurrentPageChange: _this.handlePageChange,
                                                        totalCount: filteredLines.length,
                                                        pageSize: _this.pageSize
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateLineDialog, {
                            open: _this.state.createModalOpen,
                            handleOpenClose: _this.handleModalOpenClose(!_this.state.createModalOpen)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_fab/* default */.Z, {
                            title: createLineFeature ? t([
                                "line:createNewLine"
                            ], {
                                defaultValue: "Create new line"
                            }) : t([
                                "line:noPermissionToCreateLine"
                            ], {
                                defaultValue: "You don't have permission to create a new line"
                            }),
                            disabled: !createLineFeature,
                            onClick: _this.handleModalOpenClose(true)
                        })
                    ]
                });
            }
        });
    };
    return LineCardPage;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)(with_line/* withLine */.X, with_iam/* withIAM */.$, router.withRouter, (0,withTranslation/* withTranslation */.Z)([
    "shared",
    "line"
]), (0,with_styles/* withStyles */.D)(styles), (0,with_width/* withWidth */.of)());
/* harmony default export */ var overview_page = (enhance(LineCardPage));

;// CONCATENATED MODULE: ./pages/lines/index.tsx









var Lines = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useLocalStorage */._)(constants/* LOCAL_STORAGE_LINES_OVERVIEW_LAYOUT_CONFIG */.EQ, menu/* defaultCardConf */.Dx), 2), cardConf = ref[0], setCardConf = ref[1];
    var ref1 = (0,react.useState)(new Date()), timeAtLoad = ref1[0], setTimeAtLoad = ref1[1];
    var changeUpdateInterval = (0,react.useCallback)(function(interval) {
        setCardConf((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardConf), {
            refreshInterval: interval
        }));
    }, [
        cardConf
    ]);
    (0,react.useEffect)(function() {
        if (!cardConf.refreshInterval) {
            return;
        }
        var handle = setTimeout(function() {
            setTimeAtLoad(new Date());
        }, cardConf.refreshInterval);
        return function() {
            return clearTimeout(handle);
        };
    }, [
        timeAtLoad,
        cardConf.refreshInterval
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_page, {
        timeAtLoad: timeAtLoad,
        updateInterval: cardConf.refreshInterval,
        changeUpdateInterval: changeUpdateInterval
    });
};
var __N_SSG = true;
/* harmony default export */ var lines = (Lines);


/***/ })

}]);